import { Field } from 'formik';
import { DatePicker as RsuiteDatePicker } from 'rsuite';
import { useEffect, useRef } from 'react';
import '../../../node_modules/rsuite/dist/rsuite.min.css';

export const DatePicker = ({
  name,
  title,
  disabledDate,
  placement,
  placeholder,
  value,
}) => {
  const datePickerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      // Find the calendar popup element
      const calendarPopup = document.querySelector('.rs-picker-popup');
      if (calendarPopup && datePickerRef.current) {
        // Force RSuite to recalculate the position
        const datePicker = datePickerRef.current;
        if (datePicker && datePicker.updatePosition) {
          datePicker.updatePosition();
        }
      }
    };

    window.addEventListener('scroll', handleScroll, true);

    const scrollableContainers = document.querySelectorAll(
      '[style*="overflow"], .overflow-auto, .overflow-scroll'
    );
    scrollableContainers.forEach((container) => {
      container.addEventListener('scroll', handleScroll, true);
    });

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      scrollableContainers.forEach((container) => {
        container.removeEventListener('scroll', handleScroll, true);
      });
    };
  }, []);

  return (
    <Field name={name}>
      {({ meta, form: { values, setFieldValue } }) => (
        <div className="w-full">
          <p className="modal__form-el-label mb-2">{title}</p>
          <RsuiteDatePicker
            ref={datePickerRef}
            name={name}
            onChange={(date) => {
              setFieldValue(name, date);
            }}
            onChangeCalendarDate={(date) => {
              setFieldValue(name, date);
            }}
            value={values[name] !== undefined ? values[name] : value || null}
            placement={placement}
            placeholder={placeholder}
            format={'MM-dd-yyyy'}
            role="presentation"
            oneTap
            className={`custom-date-picker w-full h-[52px] rounded-[5px] bg-white text-[#92928F] flex items-center justify-between ${meta.touched && meta.error ? 'has-error' : ''}`}
            disabledDate={disabledDate}
          />
        </div>
      )}
    </Field>
  );
};
